import {WhiteBgButtonThin} from '@packages/ui';
import Image from 'next/image';
import type {Recruitment} from '../../../../../core/entities/recruitment/schema';
import {formatScheduleDataByRecruitList} from '../../../../../core/factories/recruitment/formatScheduleData';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {
  RecruitmentTagListItem,
  RecruitmentTypeListItem,
} from '../../RecruitmentTag';
import {Schedule} from './Schedule';

export const RecruitmentItemForDetail: React.FC<{
  recruitment: Recruitment;
}> = ({recruitment}) => {
  const {isPC} = useMediaQuery();

  return (
    <div className="w-full mb-24 [&:nth-last-child(1)]:mb-0 pb-24 [&:nth-last-child(1)]:pb-0 border-b-[1px] border-line border-collapse [&:nth-last-child(1)]:border-b-0">
      <div className="w-full mt-12 flex justify-between items-center">
        <div className="w-[calc(100%-72px)]">
          <ul className="flex items-center">
            <li>
              <RecruitmentTypeListItem recruitmentType={recruitment.type} />
            </li>
            {recruitment.tags.map((tag) => {
              return (
                <li key={`tag-${tag.id}`} className="ml-8">
                  <RecruitmentTagListItem recruitmentTag={tag} />
                </li>
              );
            })}
          </ul>
          <div className="mt-8 w-full">
            <CommonLink
              className="text-md text-link font-bold hover:opacity-80"
              href={`/recruiting_info/view/${recruitment.detailID}`}
              target="_blank"
            >
              {recruitment.title}
            </CommonLink>
            <p className="text-sm text-black-3 mt-8">
              {recruitment.companies[0]?.name}
            </p>
          </div>
        </div>
        <div className="ml-12 w-[60px] h-[50px] flex relative items-center justify-center">
          {recruitment.companies[0]?.logoURLs['200x150'] && (
            <Image
              src={recruitment.companies[0]?.logoURLs['200x150']}
              alt={recruitment.companies[0]?.name}
              fill
              className="object-contain relative"
            />
          )}
        </div>
      </div>
      {isPC && (
        <ul className="bg-background-1 p-12 mt-12">
          {recruitment.schedules.map((schedule) => {
            const formatedSchedule = formatScheduleDataByRecruitList(schedule);

            return <Schedule schedule={formatedSchedule} />;
          })}
        </ul>
      )}
      {!isPC && (
        <WhiteBgButtonThin
          className="w-full mt-12"
          isPrimary={false}
          label={'募集詳細をみる'}
          onClick={async () => {
            window.open(
              `/recruiting_info/view/${recruitment.detailID}`,
              '_blank',
            );
          }}
        />
      )}
    </div>
  );
};
